import React, { useEffect, useState } from "react";

import InfoTable from "../components/tables/InfoTable";
import PartnersNew from "../components/rj-components/PartnersNew";
import videoToken from "../assets/videos/ICON_TOKEN_REVEAL.mp4";
import CoinLoader from "../components/3D/CoinLoader";

function Etoken() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="bg-ink text-white mt-[80px] pb-[20px]">
      <div
        style={{
          backgroundImage: `url('https://on-the-strip-ticketing.s3.us-west-1.amazonaws.com/images/mj/header.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex flex-col items-center h-[745px] text-center"
      >
        <h1 className="mt-[52px] text-3xl font-bold leading-tight tracking-tight md:text-5xl">
          Introducing E Coin
        </h1>
        <p className="mt-1 text-xl font-semibold text-white/90 md:text-2xl">
          The Crypto Currency Ticketing Platform
        </p>
        <p className="mt-5 max-w-2xl px-6 text-sm font-normal leading-relaxed text-white/70 md:text-base">
          Developed by Evolution LLC in partnership with On The Strip Ticketing,
          the CCTP platform empowers you to buy Las Vegas show tickets using
          Bitcoin and other major cryptocurrencies.
        </p>
        <CoinLoader scale={0.5} />

        <div className="mt-auto mb-[20px]">
          <a href="https://mjevolution.com/crypto-ticketing" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
            <button className="rounded-lg bg-[#FF6600] px-10 py-3 text-base font-semibold text-white transition-colors hover:bg-[#ff7a1f]">
              Learn more
            </button>
          </a>
        </div>
      </div>

      <div className="bg-ink-700 max-w-[1000px] mx-auto pb-1 rounded-[5px] my-[10px]">
        <InfoTable />
        {/* <PartnersNew /> */}
      </div>
      <video
        src={'https://on-the-strip-ticketing.s3.us-west-1.amazonaws.com/videos/E+Coin+Version+2.mp4'}
        autoPlay
        muted
        loop
        playsInline
        className="w-full"
      ></video>
      <div className="mx-auto my-[10px] flex w-[85%] max-w-[1000px] flex-col rounded-lg bg-ink-700 px-6 py-[60px] text-center text-white md:w-[70%]">
        <h2 className="text-2xl font-bold tracking-tight md:text-3xl">
          About Evolution LLC
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] font-normal leading-relaxed text-white/70 md:text-base">
          Evolution LLC is a cutting-edge Bitcoin/Crypto software company
          offering decentralized business tools. From ticketing to P2P trading
          and mobile Bitcoin teller machines, Evolution LLC is committed to
          helping industries modernize securely and profitably.
        </p>
      </div>
    </div>
  );
}

export default Etoken;
